import styled from "styled-components";
import { WrapperContainer } from "../../../components";

export const ConsentTableWrapper = styled(WrapperContainer)`
  tbody {
    max-height: 60vh !important;
  }
`;
